// src/components/Icons.tsx — inline SVG icons (no icon-package import). Ported from
// LLABARO.jsx. Used as member expressions, e.g. <Ico.mic />.
import type { SVGProps } from "react";

type IcoProps = SVGProps<SVGSVGElement>;

const base = {
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export const Ico = {
  mic: (p: IcoProps) => (
    <svg {...base} {...p}>
      <rect x="9" y="2" width="6" height="12" rx="3" />
      <path d="M5 10a7 7 0 0 0 14 0" />
      <line x1="12" y1="19" x2="12" y2="22" />
    </svg>
  ),
  ear: (p: IcoProps) => (
    <svg {...base} {...p}>
      <path d="M6 8.5a6 6 0 1 1 12 0c0 3-2.5 3.7-3.5 5.5-.7 1.2-.3 3.5-2.5 3.5a3 3 0 0 1-3-3" />
      <path d="M9 8.5a3 3 0 0 1 6 0" />
    </svg>
  ),
  speaker: (p: IcoProps) => (
    <svg {...base} {...p}>
      <path d="M11 5 6 9H2v6h4l5 4z" />
      <path d="M15.5 8.5a5 5 0 0 1 0 7" />
      <path d="M18.5 5.5a9 9 0 0 1 0 13" />
    </svg>
  ),
  swap: (p: IcoProps) => (
    <svg {...base} {...p}>
      <path d="M4 8h13l-3-3" />
      <path d="M20 16H7l3 3" />
    </svg>
  ),
  key: (p: IcoProps) => (
    <svg {...base} {...p}>
      <circle cx="8" cy="8" r="5" />
      <path d="M11.5 11.5 21 21" />
      <path d="M17 17l2-2" />
      <path d="M19 15l2-2" />
    </svg>
  ),
  gear: (p: IcoProps) => (
    <svg {...base} {...p}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  ),
  close: (p: IcoProps) => (
    <svg {...base} {...p}>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
};
